import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { HashRouter as Router, Route, Redirect } from "react-router-dom";
import CustomerDashboardPage from "./pages/DashboardPage_Customer";
import DashboardPageGlobal from "./pages/DashboardPageGlobal";
import DashboardPageGlobalOldUI from "./pages/DashboardPageGlobalOldUI";
import ManagerDashboardPage from "./pages/DashboardPage_Manager";
import ManagerDashboardPageDrill from "./pages/DashboardPage_Manager";
import NeedsActionPage from "./pages/NeedsActionPage";
import NeedsActionCategory from "./pages/NeedsActionCategory";
import NeedsActionDetail from "./pages/NeedsActionDetail";
import MWOPage from "./pages/MWOPage";
import UploadPage from "./pages/UploadPage";
import LoginPage from "./pages/LoginPage";
import { isAuthenticated } from "./auth";

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (isAuthenticated()) return <Component {...props} />;
      // Pass sid/user and returnUrl to login page for SSO support (TSP-126)
      const search = props.location.search || "";
      const params = new URLSearchParams(search);
      const sid = params.get("sid");
      const ssoUser = params.get("user");
      // Build returnUrl without SSO params
      params.delete("sid");
      params.delete("user");
      const cleanSearch = params.toString() ? `?${params.toString()}` : "";
      const returnUrl = props.location.pathname + cleanSearch;
      let loginPath = "/login?returnUrl=" + encodeURIComponent(returnUrl);
      if (sid) loginPath += "&sid=" + encodeURIComponent(sid);
      else if (ssoUser) loginPath += "&user=" + encodeURIComponent(ssoUser);
      return <Redirect to={loginPath} />;
    }}
  />
);

ReactDOM.render(
  <Router>
    <App>
      <Route exact path="/login" component={LoginPage} />
      <PrivateRoute exact path="/" component={() => <Redirect to="/needsaction" />} />
      <PrivateRoute key="global" exact path="/global" component={DashboardPageGlobalOldUI} />
      <PrivateRoute key="global-old" exact path="/global-old" component={DashboardPageGlobal} />
      <PrivateRoute key="customer" exact path="/customer" component={CustomerDashboardPage} />
      <PrivateRoute key="manager" exact path="/manager" component={ManagerDashboardPage} />
      <PrivateRoute key="drill" exact path="/drill" component={ManagerDashboardPageDrill} />
      <PrivateRoute key="needsaction" exact path="/needsaction" component={NeedsActionPage} />
      <PrivateRoute key="needsaction-category" exact path="/needsaction/category" component={NeedsActionCategory} />
      <PrivateRoute key="needsaction-detail" exact path="/needsaction/detail" component={NeedsActionDetail} />
      <PrivateRoute key="mwo" exact path="/mwo" component={MWOPage} />
      {/* Picture-management mini-app. /managepictures is the canonical
          route; /upload is kept as a back-compat alias so any in-flight
          links (older Etendo builds, emails, bookmarks) keep working.
          These are plain Routes, not PrivateRoutes: anonymous users get a
          read-only view (TSP-121). UploadPage gates every write action on
          isAuthenticated() itself, so it does not need route-level auth. */}
      <Route key="managepictures" exact path="/managepictures" component={UploadPage} />
      <Route key="upload" exact path="/upload" component={UploadPage} />
    </App>
  </Router>,
  document.getElementById("root")
);

serviceWorker.unregister();
